// extracted by mini-css-extract-plugin
export default {"brands-section":"style_brands-section__Won+i","brands-container":"style_brands-container__oHn2C","brand-logo":"style_brand-logo__XDfdV"};